import dynamic from 'next/dynamic';

const BoatProFooter = dynamic(() =>
  import(/* webpackChunkName: "boatWebBoatProFooter" */ '../../../../components/BoatProFooter')
);

const CardsBlock = dynamic(() =>
  import(/* webpackChunkName: "boatWebCardsBlock" */ '../../../../components/CardsBlock')
);

const ContactButtons = dynamic(() =>
  import(/* webpackChunkName: "boatWebContactButtons" */ '../../../../components/ContactButtons')
);

const ContactForm = dynamic(() =>
  import(/* webpackChunkName: "boatWebContactForm" */ '../../../../components/ContactForm')
);

const EcommerceButtons = dynamic(() =>
  import(/* webpackChunkName: "boatWebEcommerceButtons" */ '../../../../components/EcommerceButtons')
);

const EcommerceImpression = dynamic(() =>
  import(/* webpackChunkName: "boatWebEcommerceImpression" */ '../../../../components/EcommerceImpression')
);

const EcommerceProductView = dynamic(() =>
  import(/* webpackChunkName: "boatWebEcommerceProductView" */ '../../../../components/EcommerceProductView')
);

const Header = dynamic(() =>
  import(/* webpackChunkName: "boatWebHeader" */ '../../../../components/Header')
);

const NewsletterSignup = dynamic(() =>
  import(/* webpackChunkName: "boatWebNewsletterSignup" */ '../../../../components/NewsletterSignup')
);

const OnwardJourney = dynamic(() =>
  import(/* webpackChunkName: "boatWebOnwardJourney" */ '../../../../components/OnwardJourney')
);

const RegistrationForm = dynamic(() =>
  import(/* webpackChunkName: "boatWebRegistrationForm" */ '../../../../components/RegistrationForm/RegistrationForm')
);

const RestrictedUserUpdateForm = dynamic(() =>
  import(/* webpackChunkName: "boatWebRegistrationForm" */ '../../../../components/RegistrationForm/RestrictedUserUpdateForm')
);

const SalesforceLead = dynamic(() =>
  import(/* webpackChunkName: "boatWebSalesforceLead" */ '../../../../components/SalesforceLead')
);

const StickyRow = dynamic(() =>
  import(/* webpackChunkName: "boatWebStickyRow" */ '../../../../components/StickyRow')
);

const VisibilityTracking = dynamic(() =>
  import(/* webpackChunkName: "boatWebVisibilityTracking" */ '../../../../components/VisibilityTracking')
);

const YachtDescription = dynamic(() =>
  import(/* webpackChunkName: "boatWebYachtDescription" */ '../../../../components/YachtDescription')
);

const YachtSearchLink = dynamic(() =>
  import(/* webpackChunkName: "boatWebYachtSearchLink" */ '../../../../components/YachtSearchLink')
);

const UserAccessRefresh = dynamic(() =>
  import(/* webpackChunkName: "boatWebYachtSearchLink" */ '../../../../components/UserAccessRefresh')
);

const CharterRateSummary = dynamic(() =>
  import(/* webpackChunkName: "boatWebCharterRateSummary" */ '../../../../components/CharterRateSummary')
);

const CharterCruisingAreas = dynamic(() =>
  import(/* webpackChunkName: "boatWebCharterCruisingAreas" */ '../../../../components/CharterCruisingAreas')
);

const pageBuilderComponent = {
  'boat-pro-footer': BoatProFooter,
  'cards-block': CardsBlock,
  'contact-buttons': ContactButtons,
  'contact-form': ContactForm,
  'charter-rate-summary': CharterRateSummary,
  'charter-cruising-areas': CharterCruisingAreas,
  'ecommerce-buttons': EcommerceButtons,
  'ecommerce-impression': EcommerceImpression,
  'ecommerce-product-view': EcommerceProductView,
  header: Header,
  'newsletter-signup': NewsletterSignup,
  'onward-journey': OnwardJourney,
  'registration-form': RegistrationForm,
  'restricted-user-update-form': RestrictedUserUpdateForm,
  'salesforce-lead': SalesforceLead,
  'sticky-row': StickyRow,
  'visibility-tracking': VisibilityTracking,
  'yacht-description': YachtDescription,
  'yacht-search-link': YachtSearchLink,
  'user-access-refresh': UserAccessRefresh
};

export default pageBuilderComponent;
